import gsap from 'gsap';

export default {

    init() {
        if ($('#ecosystem-graphic').length < 1) return;
        this.setupAnimation();
    },

    setupAnimation() {
        let dotsRight = $('#right-side-dots path');
        let dotsUpper = $('#upper-dots path');
        let dotsBottom = $('#bottom-dots path');


        let tl1 = gsap.timeline({repeat: -1});
        tl1.to(dotsRight, {
            duration: 1,
            scale: 2.2,
            transformOrigin: 'center',
            stagger: {
                amount: 5,
                grid: 'auto',
                from: 'center',
            },
        });
        tl1.to(dotsRight, {
            duration: 1,
            scale: 1,
            transformOrigin: 'center',
            stagger: {
                amount: 5,
                grid: 'auto',
                from: 'center',
            },
        }, '<1');

        let tl2 = gsap.timeline({repeat: -1});
        tl2.to(dotsUpper, {
            duration: 1,
            scale: 2.2,
            transformOrigin: 'center',
            stagger: {
                amount: 5,
                grid: 'auto',
                from: 'center',
            },
        }, 0);
        tl2.to(dotsUpper, {
            duration: 1,
            scale: 1,
            transformOrigin: 'center',
            stagger: {
                amount: 5,
                grid: 'auto',
                from: 'center',
            },
        }, '<1');

        let tl3 = gsap.timeline({repeat: -1});
        tl3.to(dotsBottom, {
            duration: 1.3,
            scale: 2.2,
            transformOrigin: 'center',
            stagger: {
                amount: 5,
                grid: 'auto',
                from: 'center',
            },
        }, 0);
        tl3.to(dotsBottom, {
            duration: 1.3,
            scale: 1,
            transformOrigin: 'center',
            stagger: {
                amount: 5,
                grid: 'auto',
                from: 'center',
            },
        }, '<0.8');

        //let tl4 = gsap.timeline({repeat: -1});
        gsap.to($('.green-circle'), {
            duration: 2,
            scale: 1.15,
            yoyo: true,
            repeat: -1,
            transformOrigin: 'center',
        });
        gsap.to($('.purple-circle'), {
            duration: 2,
            scale: 1.2,
            yoyo: true,
            repeat: -1,
            delay: .25,
            transformOrigin: 'center',
        });
        gsap.to($('.blue-circle'), {
            duration: 2,
            scale: 1.2,
            yoyo: true,
            repeat: -1,
            delay: .5,
            transformOrigin: 'center',
        });

    },
};
